import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      levelComponent: 'levelComponent',
      disabledFullScreens: 'disabledFullScreens'
    }),
    hasProgressComponent() {
      return this.levelComponent && this.levelComponent.progress
    }
  },
  /**
   * Sets the ui to bubble/fullscreen mode
   */
  created() {
    let isFullScreen = !this.disabledFullScreens.find(item => item === this.levelComponent.id)
    this.$emit('setWindowMode', isFullScreen)
  },
  methods: {
    trackEvent(action, label, value) {
        dataLayer = window.dataLayer || [];
        dataLayer.push(
            {
                event: `product-advisor__${action}`,
                event_category: 'RUCKSACKBERATER',
                event_label: label,
                value: value
            }
        )
    },
    /**
     * Performs action based on the answer the user has been given.
     * @param answer
     */
    performAction(answer) {
      if (answer.value || answer.text) {
        this.$store.commit('addValue', answer.value || answer.text)
      }

      if (answer.action) {
        // Closes the dialog with the quit command.
        // It can be triggered everywhere in this process.
        if (answer.action.startsWith('quit')) {
          this.$store.commit('setCurrentLevel', 'PRE0')
          this.$emit('quit')
        }

        // This command starts with jump: followed by the id
        // where the jump follows up to. e.g. jump:PRE0
        // Schema: jump:{ID}
        if (answer.action.startsWith('jump:')) {
          let jumpTarget = answer.action.split(':')[1]
          if (jumpTarget) {
            this.$store.commit('setCurrentLevel', jumpTarget)

            // Track event
            let q = null
            if (answer.text) {
              q = answer.text.substr(0, answer.text.lastIndexOf('.'))
            }
            this.trackEvent('select', this.$i18n.t(q), this.$i18n.t(answer.text))
          }
        }

        // This command redirects the webpage to given target
        if (answer.action.startsWith('redirect:')) {
          let target = answer.action.split(':')[1]
          if (target) {
            switch (target) {
              case 'cart':
                this.trackEvent('select', 'goto-cart', 'goto-cart')
                window.location.href = process.env.VUE_APP_BASE_URL
                  + '/' + this.$i18n.locale + '-' + this.$i18n.locale
                  + process.env.VUE_APP_CART_URL
                break
            }
          }
        }
      }
    }
  },
}
